import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { DeliveryFeesDeliveryChargeFragmentDoc } from './DeliveryFeesDeliveryCharge.generated'
import * as Types from './purchasePlus_graphql'

export const GetProductModalSupplierDeliveryFeesDocument = gql`
  query GetProductModalSupplierDeliveryFees($tradeRelationshipId: Int!) {
    tradeRelationship(id: $tradeRelationshipId) {
      id
      deliveryCharge {
        ...DeliveryFeesDeliveryCharge
      }
    }
  }
  ${DeliveryFeesDeliveryChargeFragmentDoc}
` as unknown as DocumentNode<
  Types.GetProductModalSupplierDeliveryFeesQuery,
  Types.GetProductModalSupplierDeliveryFeesQueryVariables
>
